import { type AvailableCountry, type GTMStatus } from '@/models';
const push = (data: Record<string, string>) => {
  if (typeof window !== 'undefined' && window.dataLayer !== undefined) {
    window.dataLayer.push(data);
  }
};

export const sendGTMApplicationStart = ({
  applicationId,
  country,
  productVariant,
}: {
  applicationId: string;
  country: AvailableCountry;
  productVariant: string;
}): void => {
  push({
    ApplicationID: applicationId,
    BuisinessVertical: 'B2C',
    event: 'ApplicationStart',
    Market: country,
    Product: 'Deposit',
    ProductVariant: productVariant,
  });
};

export const sendGTMApplicationProgress = ({
  applicationId,
  country,
  productVariant,
  stepName,
  stepNumber,
}: {
  applicationId: string;
  country: AvailableCountry;
  productVariant: string;
  stepName: string;
  stepNumber: number;
}): void => {
  push({
    ApplicationID: applicationId,
    BuisinessVertical: 'B2C',
    event: 'ApplicationProgress',
    Market: country,
    Product: 'Deposit',
    ProductVariant: productVariant,
    StepName: stepName,
    StepNumber: stepNumber.toString(),
  });
};

export const sendGTMApplicationSubmitted = ({
  applicationId,
  country,
  productVariant,
  stepName,
  stepNumber,
}: {
  applicationId: string;
  country: AvailableCountry;
  productVariant: string;
  stepName: string;
  stepNumber: number;
}): void => {
  push({
    ApplicationID: applicationId,
    BuisinessVertical: 'B2C',
    event: 'ApplicationSubmitted',
    Market: country,
    Product: 'Deposit',
    ProductVariant: productVariant,
    StepName: stepName,
    StepNumber: stepNumber.toString(),
  });
};

export const sendGTMApplicationFeedback = (
  applicationId: string,
  productVariant: string,
  stars: number,
  feedback: string,
  allowFollowUp: boolean,
  country: AvailableCountry,
): void => {
  push({
    AllowFollowUp: allowFollowUp ? 'Yes' : 'No',
    ApplicationID: applicationId,
    BuisinessVertical: 'B2C',
    event: 'ApplicationCompleted',
    Feedback: feedback,
    Market: country,
    Product: 'Deposit',
    ProductVariant: productVariant,
    Stars: stars.toString(),
  });
};

export const sendGTMApplicationStatus = ({
  applicationId,
  country,
  productVariant,
  status,
  stepName,
}: {
  applicationId: string;
  country: AvailableCountry;
  productVariant: string;
  status: GTMStatus;
  stepName: string;
}): void => {
  push({
    ApplicationID: applicationId,
    BuisinessVertical: 'B2C',
    event: 'ApplicationStatus',
    Market: country,
    Product: 'Deposit',
    ProductVariant: productVariant,
    Status: status,
    StepName: stepName,
    StepNumber: 'undefined',
  });
};

export const sendGTMProductCategory = (
  productVariant: string,
  country: AvailableCountry,
): void => {
  push({
    BuisinessVertical: 'B2C',
    event: 'ProductCategory',
    Market: country,
    Product: 'Deposit',
    ProductVariant: productVariant,
  });
};

export const sendGTMFormInteraction = (
  formName: string,
  productVariant: string,
  country: AvailableCountry,
): void => {
  push({
    BuininessVertical: 'B2C',
    event: 'FormInteraction',
    FormName: formName,
    FormType: 'PDF',
    Market: country,
    Product: 'Deposit',
    ProductVariant: productVariant,
  });
};
